export default "__VITE_ASSET__wiWzIAPj__"